import React, { useEffect } from "react";
import { ConcentricCircles } from "./ConcentricCircles.chart";
import { DroppersBreakdownChart } from "./DroppersBreakdown.chart";
import { useUserStats } from "../../store/useUserStats";

export const UserStatsCircleCharts = () => {
  const { userStats, getUserStats } = useUserStats();

  useEffect(() => {
    getUserStats({ period: "all", ignoreLocation: true });
  }, [getUserStats]);

  return (
    <div className="flex flex-row gap-4 mb-4 sm:mb-8 mt-4">
      {userStats ? (
        <ConcentricCircles
          stats={[
            ...(userStats?.allDownloads &&
            userStats?.droppers &&
            userStats?.regularDroppers &&
            userStats.allDownloads >
              (userStats.droppers + userStats.regularDroppers) * 2.5
              ? []
              : [
                  {
                    label: "Downloads (registered accounts)",
                    value: userStats?.allDownloads || 0,
                    style: "bg-orange-200 border-2 border-orange-500",
                    tooltip: "Total downloads by registered accounts",
                  },
                ]),
            {
              label: "Droppers",
              value: userStats?.droppers || 0,
              style: "bg-purple-200 border-2 border-purple-500",
              tooltip: "Total users with 1 or more drops",
            },
            {
              label: "Regular droppers",
              value: userStats?.regularDroppers || 0,
              style: "bg-cyan-200 border-2 border-cyan-500",
              tooltip: "Total users with 2 or more drops",
            },
          ]}
        />
      ) : null}
      {userStats?.droppers && userStats?.regularDroppers ? (
        <DroppersBreakdownChart
          active={userStats.activeDroppers}
          inactive={userStats.inactiveDroppers}
        />
      ) : null}
    </div>
  );
};
